// Central operational-currency formatting. Display only — amounts are NEVER converted.
// SaaS subscription screens (PlanSelection/Billing/PlansManagement) intentionally stay in EUR.

export const CURRENCIES = {
  EUR: { code: "EUR", locale: "es-ES", label: "Euro (EUR, €)" },
  USD: { code: "USD", locale: "en-US", label: "Dólar EE.UU. (USD, $)" },
  CAD: { code: "CAD", locale: "en-CA", label: "Dólar canadiense (CAD, $)" },
  CLP: { code: "CLP", locale: "es-CL", label: "Peso chileno (CLP, $)" },
  GBP: { code: "GBP", locale: "en-GB", label: "Libra esterlina (GBP, £)" },
  MXN: { code: "MXN", locale: "es-MX", label: "Peso mexicano (MXN, $)" },
  ARS: { code: "ARS", locale: "es-AR", label: "Peso argentino (ARS, $)" },
  CHF: { code: "CHF", locale: "de-CH", label: "Franco suizo (CHF)" },
};

let activeCurrency = "EUR";
try {
  const saved = localStorage.getItem("store_currency");
  if (saved && CURRENCIES[saved]) activeCurrency = saved;
} catch {
  // localStorage unavailable (tests) — keep EUR
}

export function setActiveCurrency(code) {
  if (CURRENCIES[code]) activeCurrency = code;
}

export function getActiveCurrency() {
  return activeCurrency;
}

const formatterCache = {};
function getFormatter(code, display = "symbol") {
  const key = `${code}|${display}`;
  if (!formatterCache[key]) {
    const cfg = CURRENCIES[code] || CURRENCIES.EUR;
    formatterCache[key] = new Intl.NumberFormat(cfg.locale, {
      style: "currency",
      currency: cfg.code,
      currencyDisplay: display,
    });
  }
  return formatterCache[key];
}

function safeNumber(amount) {
  const n = typeof amount === "string" ? parseFloat(amount) : Number(amount);
  return Number.isFinite(n) ? n : 0;
}

export function formatCurrency(amount, currency) {
  const code = CURRENCIES[currency] ? currency : activeCurrency;
  return getFormatter(code).format(safeNumber(amount));
}

export function getCurrencySymbol(currency) {
  const code = CURRENCIES[currency] ? currency : activeCurrency;
  const part = getFormatter(code)
    .formatToParts(1)
    .find((p) => p.type === "currency");
  return part ? part.value : code;
}

// Thermal (ESC/POS) safe: € and $ print fine on common codepages; otherwise ISO code.
export function formatCurrencyThermal(amount, currency) {
  const code = CURRENCIES[currency] ? currency : activeCurrency;
  const symbol = getCurrencySymbol(code);
  if (symbol === "€" || symbol === "$") return formatCurrency(amount, code);
  return getFormatter(code, "code").format(safeNumber(amount));
}
